import { TRUSTED_LOGOS } from "@/lib/content";

/**
 * Continuously-scrolling logo marquee.
 * CSS-driven for buttery smooth performance.
 */
export default function LogoMarquee() {
  const loop = [...TRUSTED_LOGOS, ...TRUSTED_LOGOS];
  return (
    <section data-testid="logo-marquee" className="border-y border-gray-200 bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-12 pb-4">
        <div className="overline text-charcoal-soft">Trusted by organizations across healthcare, government, and professional services</div>
      </div>
      <div className="marquee-wrap py-8">
        <div className="marquee-track">
          {loop.map((src, i) => (
            <div key={i} className="marquee-item">
              <img
                src={src}
                alt=""
                loading="lazy"
                className="h-8 md:h-10 w-auto opacity-70 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .marquee-wrap { position: relative; overflow: hidden; -webkit-mask-image: linear-gradient(to right, transparent, #000 8%, #000 92%, transparent); mask-image: linear-gradient(to right, transparent, #000 8%, #000 92%, transparent); }
        .marquee-track { display: flex; gap: 4rem; width: max-content; animation: marquee 40s linear infinite; }
        .marquee-item { display: flex; align-items: center; }
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .marquee-wrap:hover .marquee-track { animation-play-state: paused; }
      `}</style>
    </section>
  );
}
